import { useTranslation } from 'react-i18next';

export default function BenefitsSection() {
  const { t } = useTranslation('home');

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 text-center mb-12 md:mb-16">
          {t('benefits_title')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <div className="relative rounded-2xl overflow-hidden flex flex-col justify-end min-h-[320px]">
            <img
              src="https://readdy.ai/api/search-image?query=Close%20up%20macro%20product%20photography%20of%20a%20single%20premium%20leather%20sneaker%20with%20white%20cotton%20laces%20placed%20on%20warm%20textured%20travertine%20stone%20surface%20late%20afternoon%20golden%20light%20streaming%20diagonally%20across%20the%20composition%20creating%20dramatic%20chiaroscuro%20shadows%20rich%20cognac%20brown%20and%20cream%20tones%20luxury%20fashion%20editorial%20style%20minimal%20composition%20with%20elegant%20simplicity%20fine%20craftsmanship%20details%20visible%20stitching%20and%20texture&width=800&height=600&seq=benefit-1-v7&orientation=landscape"
              alt="CSSBuy Spreadsheet atualização diária"
              title="Links Atualizados Diariamente - CSSBuy Spreadsheet"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
            <div className="relative z-10 p-6 md:p-8">
              <div className="w-10 h-10 rounded-full bg-background-50/15 backdrop-blur-sm flex items-center justify-center mb-4">
                <i className="ri-refresh-line text-lg text-background-50"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-heading font-bold text-background-50 mb-2">
                {t('benefit_1_title')}
              </h3>
              <p className="text-sm text-background-50/80 leading-relaxed">
                {t('benefit_1_desc')}
              </p>
            </div>
          </div>

          <div className="relative rounded-2xl overflow-hidden flex flex-col justify-end min-h-[320px]">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20garment%20rack%20photography%20displaying%20a%20curated%20collection%20of%20hanging%20clothing%20pieces%20including%20a%20camel%20wool%20coat%20cream%20linen%20shirt%20sage%20green%20trousers%20and%20caramel%20knit%20sweater%20arranged%20in%20a%20stylish%20boutique%20setting%20natural%20diffused%20window%20light%20from%20large%20arched%20window%20creating%20soft%20gentle%20illumination%20warm%20oatmeal%20and%20olive%20tones%20sophisticated%20retail%20fashion%20display%20editorial%20clothing%20catalog%20aesthetic%20clean%20minimal%20styling&width=800&height=600&seq=benefit-2-v7&orientation=landscape"
              alt="CSSBuy Spreadsheet categories"
              title="14 Categorias CSSBuy Spreadsheet"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/25 to-transparent"></div>
            <div className="relative z-10 p-6 md:p-8">
              <span className="inline-block px-3 py-1 bg-background-50/20 backdrop-blur-sm rounded-full text-xs text-background-50 mb-3">
                <span className="w-3 h-3 flex items-center justify-center inline mr-1">
                  <i className="ri-grid-line"></i>
                </span>
                14 Categorias
              </span>
              <h3 className="text-xl md:text-2xl font-heading font-bold text-background-50">
                {t('benefit_2_title')}
              </h3>
            </div>
          </div>

          <div className="relative rounded-2xl overflow-hidden flex flex-col justify-end min-h-[320px]">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20cozy%20workspace%20photography%20featuring%20an%20open%20leather%20bound%20notebook%20with%20handwritten%20shopping%20notes%20beside%20a%20ceramic%20coffee%20cup%20and%20a%20tablet%20displaying%20fashion%20items%20placed%20on%20a%20rustic%20reclaimed%20oak%20wooden%20desk%20soft%20morning%20sunlight%20filtering%20through%20sheer%20linen%20curtains%20potted%20olive%20plant%20on%20the%20side%20creating%20organic%20shadows%20warm%20caramel%20beige%20and%20olive%20green%20tones%20slow%20living%20aesthetic&width=800&height=600&seq=benefit-3-v7&orientation=landscape"
              alt="CSSBuy Spreadsheet guias SEO"
              title="Guias Completos CSSBuy Spreadsheet"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/20 to-transparent"></div>
            <div className="relative z-10 p-6 md:p-8">
              <div className="rounded-xl bg-background-50/15 backdrop-blur-sm p-3 flex items-center gap-3 mb-4 w-fit">
                <span className="w-8 h-8 rounded-full bg-accent-500 flex items-center justify-center flex-shrink-0">
                  <i className="ri-article-line text-sm text-background-50"></i>
                </span>
                <span className="text-xs text-background-50 font-medium">Guia Completo 2026</span>
              </div>
              <h3 className="text-xl md:text-2xl font-heading font-bold text-background-50 mb-2">
                {t('benefit_3_title')}
              </h3>
              <p className="text-sm text-background-50/80 leading-relaxed">
                {t('benefit_3_desc')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}